import { Theme } from '@mui/material/styles';

export const label = (theme: Theme) => ({
    marginTop: theme.spacing(2.5),
    alignItems: 'flex-start',
    color: 'text.secondary',
    textAlign: 'justify',

    '& .MuiTypography-root': {
        fontSize: '0.75rem !important',
    },
}) as const;

export const checkbox = (theme: Theme) => ({
    marginTop: theme.spacing(-1.25),
}) as const;

export const helper = {
    marginLeft: 0,
    marginTop: 0,
} as const;
